import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CheckIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.46 6.2L20.9 7.64L10.42 18.1L3.98 11.64L5.42 10.2L10.42 15.2L19.46 6.2Z" />
    </SvgIcon>
  );
});
